export const RichTextCssTextStyles = [
  '.text-large { font-size: 18px; }',
  '.text-small { font-size: 12px; }',
  '.text-extra-small { font-size: 10px; }',
].join('\n');
